import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fiTranslations from './locales/fi.json';
import enTranslations from './locales/en.json';
import csTranslations from './locales/cs.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fi: {
        translation: fiTranslations,
      },
      en: {
        translation: enTranslations,
      },
      cs: {
        translation: csTranslations,
      },
    },
    // lng: 'fi', // Odstraněno pro aktivaci autodetekce
    fallbackLng: 'fi',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;

